import airbnbImgOne from "../../img/airBnb/airbnb-1.jpg";
import airbnbImgTwo from "../../img/airBnb/airbnb-2.jpg";
import airbnbImgThree from "../../img/airBnb/airbnb-3.jpg";
import airbnbImgFour from "../../img/airBnb/airbnb-4.jpg";
import airbnbImgFive from "../../img/airBnb/airbnb-5.jpg";
import airbnbImgSix from "../../img/airBnb/airbnb-6.jpg";
import airbnbImgSeven from "../../img/airBnb/airbnb-7.jpg";
import airbnbImgEight from "../../img/airBnb/airbnb-8.jpg";
import airbnbImgNine from "../../img/airBnb/airbnb-9.jpg";
import airbnbImgTen from "../../img/airBnb/airbnb-10.jpg";
import airbnbImgEleven from "../../img/airBnb/airbnb-11.jpg";
import airbnbImgTwelve from "../../img/airBnb/airbnb-12.jpg";
import airbnbImgThirteen from "../../img/airBnb/airbnb-14.jpg";
import airbnbImgFourteen from "../../img/airBnb/airbnb-15.jpg";
import airbnbImgFifteen from "../../img/airBnb/airbnb-16.jpg";
import airbnbImgSixteen from "../../img/airBnb/airbnb-17.jpg";
import airbnbImgEighteen from "../../img/airBnb/airbnb-18.jpg";
import airbnbImgNineteen from "../../img/airBnb/airbnb-19.jpg";
import airbnbImgTwenty from "../../img/airBnb/airbnb-20.jpg";
import airbnbImgTwentyOne from "../../img/airBnb/airbnb-21.jpg";
import airbnbImgTwentyTwo from "../../img/airBnb/airbnb-22.jpg";
import airbnbImgTwentyFour from "../../img/airBnb/airbnb-23.jpg";
import airbnbImgTwentyFive from "../../img/airBnb/airbnb-24.jpg";
import airbnbImgTwentySix from "../../img/airBnb/airbnb-25.jpg";
import airbnbImgTwentySeven from "../../img/airBnb/airbnb-26.jpg";
import airbnbImgTwentyEight from "../../img/airBnb/airbnb-27.jpg";
import airbnbImgTwentyNine from "../../img/airBnb/airbnb-28.jpg";
import airbnbImgThirty from "../../img/airBnb/airbnb-29.jpg";
import airbnbImgThirtyOne from "../../img/airBnb/airbnb-30.jpg";
import airbnbImgThirtyTwo from "../../img/airBnb/airbnb-31.jpg";
import airbnbImgThirtyThree from "../../img/airBnb/airbnb-32.jpg";
import airbnbImgThirtyFour from "../../img/airBnb/airbnb-33.jpg";
import airbnbImgThirtyFive from "../../img/airBnb/airbnb-34.jpg";
import airbnbImgThirtySix from "../../img/airBnb/airbnb-35.jpg";
import airbnbImgThirtySeven from "../../img/airBnb/airbnb-36.jpg";
import airbnbImgThirtyEight from "../../img/airBnb/airbnb-37.jpg";
import airbnbImgThirtyNine from "../../img/airBnb/airbnb-38.jpg";
import airbnbImgFourty from "../../img/airBnb/airbnb-39.jpg";
import airbnbImgFourtyOne from "../../img/airBnb/airbnb-40.jpg";



const AirBnbImagesArray = [
    airbnbImgOne,
    airbnbImgTwo,
    airbnbImgThree,
    airbnbImgFour,
    airbnbImgFive,
    airbnbImgSix,
    airbnbImgSeven,
    airbnbImgEight,
    airbnbImgNine,
    airbnbImgTen,
    airbnbImgEleven,
    airbnbImgTwelve,
    airbnbImgThirteen,
    airbnbImgFourteen,
    airbnbImgFifteen,
    airbnbImgSixteen,
    airbnbImgEighteen,
    airbnbImgNineteen,
    airbnbImgTwenty,
    airbnbImgTwentyOne,
    airbnbImgTwentyTwo,
    airbnbImgTwentyFour,
    airbnbImgTwentyFive,
    airbnbImgTwentySix,
    airbnbImgTwentySeven,
    airbnbImgTwentyEight,
    airbnbImgTwentyNine,
    airbnbImgThirty,
    airbnbImgThirtyOne,
    airbnbImgThirtyTwo,
    airbnbImgThirtyThree,
    airbnbImgThirtyFour,
    airbnbImgThirtyFive,
    airbnbImgThirtySix,
    airbnbImgThirtySeven,
    airbnbImgThirtyEight,
    airbnbImgThirtyNine,
    airbnbImgFourty,
    airbnbImgFourtyOne
]

export default AirBnbImagesArray;